import { render } from "./ThePromocode.vue?vue&type=template&id=1f924874&scoped=true&ts=true&lang=html"
import script from "./ThePromocode.vue?vue&type=script&lang=ts"
export * from "./ThePromocode.vue?vue&type=script&lang=ts"

import "./ThePromocode.vue?vue&type=style&index=0&id=1f924874&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f924874"]])

export default __exports__